import { useEffect, useState } from "react";
import { tiposIndividuoOptions, classesRiscoOptions, reviewStatusLabel } from "@/config/cta-mapa-config";

interface TreeFiltersProps {
  onFilter: (filters: Record<string, string>) => void;
  /** Status de revisao presentes no cadastro carregado (derivados do dado real). */
  statusOptions?: string[];
}

/**
 * Filtros do cadastro.  So filtra pelo que a listagem real traz: estado fitossanitario e
 * recomendacao de manejo vem da vistoria validada (FCA) e nao estao na listagem.
 */
export default function TreeFilters({ onFilter, statusOptions = [] }: TreeFiltersProps) {
  const [search, setSearch] = useState("");
  const [tipo, setTipo] = useState("");
  const [risco, setRisco] = useState("");
  const [statusRevisao, setStatusRevisao] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  // Aplica a partir do estado ja atualizado (antes o filtro ficava um passo atras do que foi digitado).
  useEffect(() => {
    const f: Record<string, string> = {};
    if (search) f.search = search.toLowerCase();
    if (tipo) f.tipo = tipo;
    if (risco) f.risco = risco;
    if (statusRevisao) f.statusRevisao = statusRevisao;
    onFilter(f);
  }, [search, tipo, risco, statusRevisao, onFilter]);

  const clearFilters = () => {
    setSearch("");
    setTipo("");
    setRisco("");
    setStatusRevisao("");
  };

  const activeCount = [search, tipo, risco, statusRevisao].filter(Boolean).length;
  const selectClass =
    "w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50";

  return (
    <div className="bg-white rounded-card border border-background-200 p-4">
      <div className="flex items-center gap-2">
        <div className="flex-1 relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            placeholder="Buscar por código CTA, espécie, logradouro ou bairro..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 bg-background-50"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-outline text-xs px-3 py-2 cursor-pointer ${showFilters ? "border-primary-400 text-primary-600 bg-primary-50" : ""}`}
        >
          <i className="ri-filter-3-line"></i>
          Filtros
          {activeCount > 0 && (
            <span className="ml-1 w-4 h-4 rounded-full bg-primary-500 text-white text-[10px] flex items-center justify-center">
              {activeCount}
            </span>
          )}
        </button>
        {activeCount > 0 && (
          <button onClick={clearFilters} className="btn-outline text-xs px-3 py-2 cursor-pointer">
            <i className="ri-close-line"></i>
            Limpar
          </button>
        )}
      </div>

      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3 pt-3 border-t border-background-200">
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Tipo de Indivíduo</label>
            <select value={tipo} onChange={(e) => setTipo(e.target.value)} className={selectClass}>
              <option value="">Todos</option>
              {tiposIndividuoOptions.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Classe de Risco (última avaliação)</label>
            <select value={risco} onChange={(e) => setRisco(e.target.value)} className={selectClass}>
              <option value="">Todas</option>
              {classesRiscoOptions.map((r) => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </select>
          </div>
          {statusOptions.length > 0 && (
            <div>
              <label className="text-xs text-foreground-500 mb-1 block">Status de Revisão</label>
              <select value={statusRevisao} onChange={(e) => setStatusRevisao(e.target.value)} className={selectClass}>
                <option value="">Todos</option>
                {statusOptions.map((s) => (
                  <option key={s} value={s}>{reviewStatusLabel(s)}</option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
